module.exports = __webpack_public_path__ + "assets/img/marriage-form-bg1.40b910ef.png";